export default "__VITE_ASSET__DeOT8c9H__"